import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  THEME04: {
    path: `${baseRoutes.userBaseRoutes}theme04`,
  },
};

export default accessRoute;
